import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { BasePaths, AgentPaths, MemberPaths } from 'src/app/constants/routes';
import { SessionService } from 'src/app/services/storage/session.service';

@Component({
    selector: 'mwp-page-not-found',
    templateUrl: './page-not-found.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageNotFoundComponent implements OnInit {
    public redirectLabel = '';
    private redirectURL: string;
    
    constructor(
        private router: Router,
        private sessionService: SessionService
    ) {
    }

    ngOnInit() {
        if (this.sessionService.session && this.sessionService.session.isLoggedIn) {
            if (this.sessionService.session.isMember) {
                this.redirectLabel = 'Return to Dashboard';
                this.redirectURL = MemberPaths.Dashboard;
            } else {
                this.redirectLabel = 'Return to Member Lookup';
                this.redirectURL = AgentPaths.CounselorMemberLookup;
            }
        } else {
            this.redirectURL = BasePaths.Home
            this.redirectLabel = 'Return to home page';
        }
    }

    public redirectHome() {
        this.router.navigateByUrl(this.redirectURL);
    }
}